export default function Gallery() {
  const images = [
    {
      url: 'https://images.pexels.com/photos/4116291/pexels-photo-4116291.jpeg',
      title: 'Professional auto body repair equipment',
      caption: 'State-of-the-art repair equipment'
    },
    {
      url: 'https://images.pexels.com/photos/2244746/pexels-photo-2244746.jpeg',
      title: 'Expert technician performing collision repair',
      caption: 'Expert collision repair work'
    },
    {
      url: 'https://images.pexels.com/photos/19186528/pexels-photo-19186528.jpeg',
      title: 'Modern auto body shop facility',
      caption: 'Modern repair facility'
    },
    {
      url: 'https://images.pexels.com/photos/33814734/pexels-photo-33814734.jpeg',
      title: 'Professional auto painting service',
      caption: 'Professional paint services'
    },
    {
      url: 'https://images.pexels.com/photos/7568433/pexels-photo-7568433.jpeg',
      title: 'Quality auto body repair work',
      caption: 'Quality repair work'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-amber-100 rounded-full mb-4">
            <i className="ri-gallery-line text-amber-600"></i>
            <span className="text-sm text-amber-900 font-semibold">Our Work</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 font-['Space_Grotesk'] mb-4">
            See Our Quality Work
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Take a look at our state-of-the-art facility and the quality repairs we deliver every day
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 aspect-[4/3]"
            >
              <img 
                src={image.url}
                alt={image.title}
                title={image.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="text-white font-semibold text-lg">{image.caption}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
